import { ArchiveMarkerOutlineIcon } from './ArchiveMarkerOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 8639E3F6-3A01-47DF-9787-F80E273C99A2
 * name archive-marker-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-marker-outline.svg
 * tags
 * - Navigation 
 */
export const BoxLocationOutlineIcon = ArchiveMarkerOutlineIcon;
export default BoxLocationOutlineIcon